import React from 'react';
import DisplayCampaigns from './DisplayCampaigns';

export default function DemandGen() {
  return <DisplayCampaigns forceDemandGen />;
}
